import React from "react";

import { ASSETS_URL } from "configs/constant";

import { formatImage } from "@utils/helpers/logic/image";

const Company = ({ data }) => {
  return (
    <div className="news-details">
      <div className="news-details__header">
        <div
          className="news-details__header__content"
          style={{
            backgroundImage: `url(${ASSETS_URL}/${formatImage(data?.logo)})`,
          }}
        >
          <h1>{data?.title || ""}</h1>
        </div>
      </div>

      <div className="news-details__container">
        <div className="news-details__container__content">
          <div
            className="news-details__container__content--content"
            dangerouslySetInnerHTML={{ __html: data?.content }}
          />
        </div>
      </div>
    </div>
  );
};

export default Company;
